import { useHits, useInstantSearch } from "react-instantsearch";
import { useEffect, useState } from "react";

export function useAutoComplete() {
  const { status } = useInstantSearch();
  const { items } = useHits();
  const [suggestion, setSuggestion] = useState<string>("");

  useEffect(() => {
    if (status === "idle" && items.length > 0) {
      // Get the first item's query as auto-completion suggestion
      const firstItem = items[0] as any;
      if (firstItem?.query) {
        setSuggestion(firstItem.query);
      } else {
        setSuggestion("");
      }
    } else {
      setSuggestion("");
    }
  }, [items, status]);

  return suggestion;
}
